import isEqual from 'react-fast-compare';
import {useSelector} from 'react-redux';

export default function usePlatform() {
    return useSelector((ctx) => ctx.platform.mic, isEqual);
}
